import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// TODO: remove getCatalogueLink import
// This import should not be here as it introduces tight coupling
// getCatalogue link should be passed as param from parent container.
import { getCatalogueLink } from 'apps/catalogue/links';
import ViewAllLink from './ViewAllLink';
import PromosLinks from './PromosLinks';
import LevelItem from './LevelItem';

export default class LevelItemsList extends PureComponent {
  static propTypes = {
    level: PropTypes.any,
    levelIdx: PropTypes.any,

    levelIds: PropTypes.array.isRequired,
    levels: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        categories: PropTypes.arrayOf(PropTypes.shape({
          id: PropTypes.string,
          children: PropTypes.array,
          hasChildren: PropTypes.bool,
        })),
      }),
    ),
    linksRoot: PropTypes.string,
    promos: PropTypes.array,
    pageParameters: PropTypes.object,
    itemMouseOverAction: PropTypes.func.isRequired,
    onItemTouchStartAction: PropTypes.func.isRequired,
    onLeafItemMouseOver: PropTypes.func.isRequired,
    onItemMouseClick: PropTypes.func.isRequired,
    onLevelMouseOver: PropTypes.func.isRequired,
    onItemMouseOut: PropTypes.func.isRequired,
    onPromoLinkClick: PropTypes.func.isRequired,
    showPromoItems: PropTypes.bool,
    hideViewAll: PropTypes.bool,
  };

  static defaultProps = {
    pageParameters: {},
  };

  onActivate = (e, toIds) => {
    this.props.itemMouseOverAction(e, toIds);
  };

  onDeactivate = (e) => {
    this.props.onItemMouseOut(e);
  };

  onLevelItemTouchStart = (e, toIds, categoryId) =>
    this.props.onItemTouchStartAction(e, this.props.levelIds, toIds, categoryId);

  getItemLink = (linkCategory) => {
    const { pageParameters, linksRoot } = this.props;
    return getCatalogueLink({ ...pageParameters, category: linkCategory }, (linksRoot || '/browse'));
  };

  getViewAllLink = (levelCategory) => {
    const { hideViewAll, level, levelIds, levelIdx, linksRoot, onItemMouseClick, pageParameters } = this.props;

    // don't show 'View All' link for default level-1
    const showViewAllLink = Boolean(!hideViewAll && levelIdx > 0 && levelIds.length && levelIds[0] !== 'highlighted');
    const viewAllLink = getCatalogueLink({ ...pageParameters, category: levelCategory }, (linksRoot || '/browse'));

    if (!showViewAllLink) {
      return null;
    }

    return (
      <ViewAllLink
        to={viewAllLink}
        level={level}
        onItemMouseClick={onItemMouseClick}
        onDeactivate={this.onDeactivate}
      />
    );
  }

  render() {
    const {
      promos,
      levelIds,
      levels,
      level,
      levelIdx,
      pageParameters,
      onLeafItemMouseOver,
      onItemMouseClick,
      onLevelMouseOver,
      onPromoLinkClick,
      showPromoItems,
    } = this.props;

    let toIdsRoot = [];

    const levelCategory = pageParameters.category ? pageParameters.category.slice(0) : [];
    // build nested categories links
    for (let i = 1, len = levelIdx; i <= len; i++) {
      const { id, name } = levels[i];
      if (id) {
        toIdsRoot = toIdsRoot.concat([id]);
        if (id !== 'highlighted') {
          levelCategory.push({ id, name });
        }
      }
    }

    if (!level.categories && !(showPromoItems && promos)) {
      return false;
    }

    /* eslint-disable react/no-array-index-key */
    return (
      <div
        className={classNames(
          'grocery-section',
          `level-${levelIdx}`,
          {
            'level-nested': levelIdx,
          }
        )}
        onFocus={onLevelMouseOver}
        onMouseOver={onLevelMouseOver}
      >
        <ul>
          {showPromoItems && (
            <PromosLinks
              levelIdx={levelIdx}
              promos={promos}
              onLeafItemMouseOver={onLeafItemMouseOver}
              onPromoLinkClick={onPromoLinkClick}
            />
          )}
          {level.categories && level.categories.map((category, catKey) => (
            <LevelItem
              key={`${category.name}${catKey}`}
              category={category}
              itemLink={this.getItemLink(levelCategory.concat(category))}
              toIdsRoot={toIdsRoot}
              isCategoryExpanded={levelIds.includes(category.id)}
              isLeaf={!category.children && !category.hasChildren}
              levelIdx={levelIdx}
              onActivate={this.onActivate}
              onDeactivate={this.onDeactivate}
              onClick={onItemMouseClick}
              onTouchStart={this.onLevelItemTouchStart}
            />
          ))}
          {this.getViewAllLink(levelCategory)}
        </ul>
      </div>
    );
    /* eslint-enable react/no-array-index-key */
  }
}
